module.exports = __webpack_public_path__ + "img/c5Rp7Ym-Klz.ffc0fc3c.png";